import { useUserData } from "@nhost/react";
import React from "react";
import { Link } from "react-router-dom";
import { GetUserPost } from "../../hooks/usePost";

const PostByUser = () => {
  const user = useUserData();
  const author_id = user?.displayName;
  const { error, loading, data } = GetUserPost(author_id);
  if (error)
    return (
      <p className=" text-center mt-5 text-6xl font-extrabold text-lime-500 ">{`${error.message}`}</p>
    );
  if (loading)
    return (
      <p className=" text-center mt-5 text-6xl font-extrabold text-lime-500 ">
        Loading...
      </p>
    );
  if (data)
    return (
      <div className="grid grid-cols-4 gap-4 mx-10 justify-around my-9 ">
        {data?.blog_posts.map((blogPost) => (
          <div className=" shadow-2xl shadow-slate-600 rounded-lg	align mx-5 my-auto">
            <h2 className="text-2xl mx-3 uppercase font-semibold   ">
              {blogPost.category}
            </h2>
            <h2 className="mx-3 text-lg text-zinc-800 ">{blogPost.title}</h2>
            <h2 className="mx-3 overflow-hidden">{blogPost.content}</h2>
            <h2 className="mx-3 overflow-hidden">{blogPost.author_id}</h2>
            <Link className="mx-3 text-cyan-400" to={`/${blogPost.id}`}>
              Read...
            </Link>
          </div>
        ))}
      </div>
    );
};

export default PostByUser;
